import React from "react";
import {
  WIDGET_COMPONENTS,
  WIDGET_TYPES,
  MAIN_WIDGETS
} from "../../utils/dashboardComponentMapping";
import useGetData from "../Custom-Hooks/useGetData";
import { useParams } from "react-router-dom";

const getColumnClass = (count) => {
  if (count === 1) return "col-12";
  if (count === 2) return "col-6";
  if (count === 3) return "col-4";
  return "col-3";
};

const parsePreferences = (preferences) => {
  if (!preferences) return null;

  try {
    return typeof preferences === 'string'
      ? JSON.parse(preferences)
      : preferences;
  } catch (error) {
    console.error("Error parsing preferences:", error);
    return null;
  }
};

const Home = () => {
  const { pageId } = useParams();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const { data: userPreferencesData, isLoading: prefsLoading } = useGetData(
    `${baseUrl}/user/${userDetails?.id}/page/${pageId}/preferences`
  );

  const preferences = parsePreferences(userPreferencesData?.preferences);

  const selectedWidgets = 
  preferences?.selectedWidgets ||
  preferences?.widgets?.selectedWidgets ||
  [];

  const widgetIds = preferences?.selectedWidgets?.map(w => w.id) || [];

  const mainWidgetIds = widgetIds.filter(id =>
    MAIN_WIDGETS.includes(id)
  );

  const showNotification = widgetIds.includes(
    WIDGET_TYPES.NOTIFICATION_TABLE
  );

  const NotificationComponent = WIDGET_COMPONENTS[WIDGET_TYPES.NOTIFICATION_TABLE];

  const columnClass = getColumnClass(mainWidgetIds.length);

  return (
    <div className="container-fluid">
      {!prefsLoading && (!preferences || Object.keys(preferences).length === 0 || (selectedWidgets && selectedWidgets.length === 0)) && (
        <div className="mt-3 d-flex justify-content-center align-items-center fnt14">Please navigate to the user preferences and configure your widgets accordingly.</div>
      )}
      {/* Main Widgets Row */}
      {mainWidgetIds.length > 0 && (
        <div className="row px-2 gx-4">
          {mainWidgetIds.map(id => {
            const WidgetComponent = WIDGET_COMPONENTS[id];
            return WidgetComponent ? (
              <div className={columnClass} key={id}>
                <div className="card-container rounded">
                  <WidgetComponent />
                </div>
              </div>
            ) : null;
          })}
        </div>
      )}

      {/* Notification Table Section */}
      {showNotification && NotificationComponent && (
        <div className="row px-3 gx-3">
          <div className="col-12 mt-4 rounded">
            <NotificationComponent />
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;